'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var factory = require('./factory.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);

/**
 * Parse from JSON.
 *
 * @export
 * @param {(AtomJson | ExpressionJson | ConditionJson)} json
 * @param {Graph} [schema]
 * @returns {(Atom | BaseExpression | BaseCondition)}
 */
function parseExprJson(json, schema) {
  if (json !== undefined) {
    var classType = json.type;
    // Atom type.
    if (_includesInstanceProperty__default["default"](classType).call(classType, 'Accum') || _includesInstanceProperty__default["default"](classType).call(classType, 'Constant') || classType === 'AliasReference' || _includesInstanceProperty__default["default"](classType).call(classType, 'Param') || _includesInstanceProperty__default["default"](classType).call(classType, 'Variable')) {
      var factory$1 = factory.FactoryProducer.getFactory(factory.AtomFactory);
      var attributeType;
      if ((classType === 'AttrVariable' || classType === 'AttrVariableWithAlias') && json.value && schema) {
        var _context, _context4;
        _forEachInstanceProperty__default["default"](_context = schema.getAllEdgeTypes()).call(_context, function (type) {
          var _context2;
          return _forEachInstanceProperty__default["default"](_context2 = schema.getEdge(type).attributes).call(_context2, function (attr) {
            var _context3;
            if (_concatInstanceProperty__default["default"](_context3 = "".concat(type, ".")).call(_context3, attr.name) === json.value) {
              return attributeType = attr.type.getDataType();
            }
          });
        });
        _forEachInstanceProperty__default["default"](_context4 = schema.getAllVertexTypes()).call(_context4, function (type) {
          var _context5;
          _forEachInstanceProperty__default["default"](_context5 = schema.getVertex(type).attributes).call(_context5, function (attr) {
            var _context6;
            if (_concatInstanceProperty__default["default"](_context6 = "".concat(type, ".")).call(_context6, attr.name) === json.value) {
              return attributeType = attr.type.getDataType();
            }
          });
          if (schema.getVertex(type).primaryId) {
            var _context7;
            if (_concatInstanceProperty__default["default"](_context7 = "".concat(type, ".")).call(_context7, schema.getVertex(type).primaryId.name) === json.value) {
              return attributeType = schema.getVertex(type).primaryId.type.getDataType();
            }
          }
        });
      }
      return factory$1.getAtom(factory.atomDict[classType], json.value, attributeType);
      // Expression type.
    } else if (_includesInstanceProperty__default["default"](classType).call(classType, 'Expression')) {
      var _context8;
      var _factory = factory.FactoryProducer.getFactory(factory.ExpressionFactory);
      var operands = _mapInstanceProperty__default["default"](_context8 = json.operands).call(_context8, function (operand) {
        return parseExprJson(operand, schema);
      });
      return _factory.getExpression(factory.exprDict[classType], operands, json.operator);
      // Condition type.
    } else {
      var _context9;
      var _factory2 = factory.FactoryProducer.getFactory(factory.ConditionFactory);
      var _operands = _mapInstanceProperty__default["default"](_context9 = json.operands).call(_context9, function (operand) {
        return parseExprJson(operand, schema);
      });
      return _factory2.getCondition(factory.condDict[classType], _operands, json.operator);
    }
  }
}

exports.parseExprJson = parseExprJson;
